
/**
 * @fileOverview Features module definition
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('models/Features',['require'],function(require) {

        /**
         * Set of profile names referring to the interaction profiles
         *
         * @property PROFILES
         * @static
         * @final
         * @type {object}
         */
        var PROFILES = {
            /**
             * Mobile IE using the msPointer events
             * May not be limited to mobile, but hasn't been tested
             *
             * @property MOBILE_IE
             * @static
             * @final
             * @type {string}
             */
            MOBILE_IE: 'pointer',

            /**
             * Mobile safari interaction events (touch)
             *
             * @property MOBILE
             * @static
             * @final
             * @type {string}
             */
            MOBILE: 'touch',

            /**
             * Desktop mouse interaction events (mouse)
             *
             * @property MOBILE_IE
             * @static
             * @final
             * @type {string}
             */
            DESKTOP: 'mouse'
        };

        /**
         * Feature support test object
         * Stores the most recent test profile's information for events
         * Built to be a singleton
         *
         * @class FeatureSupport
         * @constructor
         */
        var FeatureSupport = function() {
            /**
             * Interaction profile that the current features support
             *
             * @property interactionProfile
             * @type {string}
             * @default PROFILES.DESKTOP
             */
            this.interactionProfile = PROFILES.DESKTOP;

            /**
             * Flag indicating the support of the current interactionProfile with the leave events
             * touch and pointer should not support leave yet
             *
             * @property useLeave
             * @type {boolean}
             * @default true
             */
            this.useLeave = true;

            /**
             * Current down event
             * mousedown, touchstart, MSPointerDown
             *
             * @property DOWN
             * @type {string}
             * @final
             */
            this.DOWN = 'mousedown';

            /**
             * Current move event
             * mousemove, touchmove, MSPointerMove
             *
             * @property MOVE
             * @type {string}
             * @final
             */
            this.MOVE = 'mousemove';

            /**
             * Current up event
             * mouseup, touchend, MSPointerUp
             *
             * @property UP
             * @type {string}
             * @final
             */
            this.UP = 'mouseup';

            /**
             * Current cancel event
             * mousecancel, touchcancel, MSPointerCancel
             *
             * @property CANCEL
             * @type {string}
             * @final
             */
            this.CANCEL = 'mousecancel';

            /**
             * Current leave event (unsupported on non-mouse systems)
             * mouseleave
             *
             * @property LEAVE
             * @type {string}
             * @final
             */
            this.LEAVE = 'mouseleave';

            this.executeTests();
            this.prepareFeatureDependentProperties();

            /**
             * Static profiles reference to the class-level profiles
             * @see PROFILES
             *
             * @property PROFILES
             * @type {object}
             */
            this.PROFILES = PROFILES;
        };

        /**
         * Executes all tests that the feature testing support requires
         *
         * @method executeTests
         */
        FeatureSupport.prototype.executeTests = function() {
            this.testInteraction();
        };

        /**
         * Tests the current interaction profile to determine which event family to use
         *
         * @method testInteraction
         */
        FeatureSupport.prototype.testInteraction = function() {
            var profile;

            // UNTESTED POINTER TEST
            // Test code gathered from: https://msdn.microsoft.com/en-us/library/ie/hh673557(v=vs.85).aspx
            if (window.navigator.msPointerEnabled) {
                profile = PROFILES.MOBILE_IE;
            } else if ('ontouchstart' in document.documentElement) {
                profile = PROFILES.MOBILE;
            } else {
                profile = PROFILES.DESKTOP;
            }

            this.interactionProfile = profile;
        };

        /**
         * Prepares any metadata to support the tested states
         *
         * @method prepareFeatureDependentProperties
         */
        FeatureSupport.prototype.prepareFeatureDependentProperties = function() {
            this.prepareInteractionEvents();
        };

        /**
         * Prepares interaction events and applies the proper pointer, touch, or mouse events
         *
         * @method prepareInteractionEvents
         */
        FeatureSupport.prototype.prepareInteractionEvents = function() {
            switch (this.interactionProfile) { // UNTESTED POINTER INTERACTIONS
            case PROFILES.MOBILE_IE:
                this.useLeaveInteraction = false;
                this.DOWN = 'MSPointerDown';
                this.MOVE = 'MSPointerMove';
                this.UP = 'MSPointerUp';
                this.CANCEL = 'MSPointerCancel';
                break;
            case PROFILES.MOBILE:
                this.useLeaveInteraction = false;
                this.DOWN = 'touchstart';
                this.MOVE = 'touchmove';
                this.UP = 'touchend';
                this.CANCEL = 'touchcancel';
                break;
            case PROFILES.DESKTOP:
                this.useLeaveInteraction = true;
                this.DOWN = 'mousedown';
                this.MOVE = 'mousemove';
                this.UP = 'mouseup';
                this.CANCEL = 'mousecancel';
                this.LEAVE = 'mouseleave';
                break;
            }
        };

        return new FeatureSupport();
    });

}(MMMRequire));
